export const desktopWidht = 1279;
export const mobileWidth = 767;
